// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScoreModal_wrapper__1-ND9","content":"ScoreModal_content__2IRvI","btn_cancel":"ScoreModal_btn_cancel__1GV1I"};